'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002493 from "./presto.-Presto-Router$$anon$93.js";
import * as $j_presto$002e$002dTest$002dPage$0024 from "./presto.-Test-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$92() {
  this.bov = null;
  this.bon = null;
  this.boo = false;
  this.bow = null;
  this.box = false;
  this.boA = null;
  this.bot = null;
  this.bou = false;
  this.bop = null;
  this.boq = false;
  this.bor = null;
  this.bos = false;
  this.boy = false;
  this.boz = false;
  this.bov = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.boA = "TestPage";
}
export { $c_Lpresto_PrestoRouter$$anon$92 as $c_Lpresto_PrestoRouter$$anon$92 };
$p = $c_Lpresto_PrestoRouter$$anon$92.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$92;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$92() {
}
export { $h_Lpresto_PrestoRouter$$anon$92 as $h_Lpresto_PrestoRouter$$anon$92 };
$h_Lpresto_PrestoRouter$$anon$92.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bov;
});
$p.M = (function() {
  if ((!this.boo)) {
    this.bon = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.boo = true;
  }
  return this.bon;
});
$p.O = (function() {
  if ((!this.box)) {
    this.bow = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.box = true;
  }
  return this.bow;
});
$p.E = (function() {
  return this.boA;
});
$p.t = (function() {
  if ((!this.bou)) {
    this.bot = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bou = true;
  }
  return this.bot;
});
$p.N = (function() {
  if ((!this.boq)) {
    this.bop = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.boq = true;
  }
  return this.bop;
});
$p.Q = (function() {
  if ((!this.bos)) {
    this.bor = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002493.$c_Lpresto_PrestoRouter$$anon$93();
    this.bos = true;
  }
  return this.bor;
});
$p.v = (function() {
  if ((!this.boz)) {
    this.boy = false;
    this.boz = true;
  }
  return this.boy;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee583) => ((p) => \u03b4scrutinee583))($j_presto$002e$002dTest$002dPage$0024.$m_Lpresto_TestPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$92 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$92, "presto.PrestoRouter$$anon$92", ({
  Pb: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$92 as $d_Lpresto_PrestoRouter$$anon$92 };
//# sourceMappingURL=presto.-Presto-Router$$anon$92.js.map
